import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from '../../shared/services/authorization.service';
import { loadRemoteModule } from '@angular-architects/module-federation';
import config from '../../../assets/config.json';

@Component({
  selector: 'app-bob-emulate',
  standalone: true,
  imports: [],
  templateUrl: './bob-emulate.component.html',
  styleUrl: './bob-emulate.component.scss',
})
export class BobEmulateComponent {
  token: string = '';
  @ViewChild('EmulationComponent', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;
  constructor(private _authservice: AuthorizationService) {
    this._authservice.getAccessToken().then((token) => {
      this.token = token;
    });
  }

  async ngOnInit() {
    const { EmulationComponent } = await loadRemoteModule({
      type: 'module',
      remoteEntry: config.bobRemoteURL,
      exposedModule: './EmulationComponent',
    });
    const componentFactory: any = this.container.createComponent(EmulationComponent);
    componentFactory.instance.token = this.token;
    componentFactory.instance.roles = this._authservice.getFormattedGroups();
    this.container.insert(componentFactory.hostView);
  }
}
